module.service('permissionStatesService', permissionStateServiceFn);

function permissionStateServiceFn(){
	var ss={};
	
	ss.canEditPlanSampling = function(state){
    	var validState = [PLAN_SAMPLING_STATE.EDITION, PLAN_SAMPLING_STATE.PROGRESS];
    	return validateState(validState, state);       	
    }
    
	ss.canInitPlanSampling = function(state){
    	var validState = [PLAN_SAMPLING_STATE.EDITION];
    	return validateState(validState, state);       	
    }
    
	ss.canCancelPlanSampling = function(state){
    	var validState = [PLAN_SAMPLING_STATE.EDITION, PLAN_SAMPLING_STATE.PROGRESS];
    	return validateState(validState, state);       	
    }
	
	ss.canSamplingGoToHome = function(state){
    	var validState = [PLAN_SAMPLING_STATE.PROGRESS, PLAN_SAMPLING_STATE.FINISHED];
    	return validateState(validState, state);       	
    }
	
	ss.canEditSampling = function(state){
    	var validState = [PLAN_SAMPLING_STATE.EDITION];
    	return validateState(validState, state);       	
    }
	
	ss.canCreateSampling = function(state){
    	var validState = [PLAN_SAMPLING_STATE.EDITION, PLAN_SAMPLING_STATE.PROGRESS];
    	return validateState(validState, state);       	
    }
	
	ss.canRemoveSampling = function(state){
    	var validState = [PLAN_SAMPLING_STATE.EDITION];
    	return validateState(validState, state);       	
    }
	
	ss.canAddSample = function(state){
		var validState = [PLAN_SAMPLING_STATE.PROGRESS];
    	return validateState(validState, state);       	
    }
	
	ss.canCancelSample = function(state){
    	var NovalidState = [SAMPLE_STATE.NOT_CONFORM, SAMPLE_STATE.CANCELED, SAMPLE_STATE.REPORTED, SAMPLE_STATE.NOT_TAKEN ];
    	return !validateState(NovalidState, state);       	
    }

	ss.canEditSample = function(state){
    	var validState = [SAMPLE_STATE.WAITING_FOR_SCHEDULE, SAMPLE_STATE.SCHEDULED, SAMPLE_STATE.ASIGNED, 
    		SAMPLE_STATE.SAMPLE_ELEMENT_CHECKED, SAMPLE_STATE.TAKEN_NOT_SIGNED];
    	return validateState(validState, state);       	
    }
	
    validateState = function(validStates, state){
    	return validStates.some(
    		function(e){
    			return e.enumName === state;
    		}
    	);
    }
	
	return ss;
}